import { AfterViewInit, Directive, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DebounceConstants } from './debounce-constants';

@Directive({
   selector: '[debouncedValueChange]',
})
export class ValueChangeDebounceDirective implements AfterViewInit, OnDestroy {
   @Output()
   public debouncedValueChange: EventEmitter<any> = new EventEmitter<any>();

   @Input()
   public debouncedValueChangeDelay = DebounceConstants.DEFAULT_DEBOUNCE;

   private stream: Subject<any> = new Subject<any>();
   private subscription: Subscription;

   constructor() {}

   ngOnDestroy(): void {
      this.subscription.unsubscribe();
   }

   @HostListener('valueChange', ['$event'])
   public onValueChange(value: any): void {
      this.stream.next(value);
   }

   ngAfterViewInit(): void {
      this.subscription = this.stream.pipe(debounceTime(this.debouncedValueChangeDelay)).subscribe((value: any) => this.debouncedValueChange.next(value));
   }
}
